const e = {
  s0289cd9e4bcf84c5: "Volume Level",
  s061cc20e3432dead: "Pause",
  s0622a6e6cb77254b: "Transcript",
  s080d032fc1b87b3f: "Audio Description",
  s08b06007b5567108: "of",
  s08e6bd98452e6bb9: "Audio",
  s1b4a36fce2456660: "Font Family",
  s1fa5be5a4f5d0f04: "Casual",
  s23537b5c9e7af982: "Captions",
  s24221a89168e9d21: "Font Size",
  s255857544a9d5ec0: "Reset",
  s25a858f0257e2879: "Captions Menu",
  s2df075aface0dab8: "Share",
  s2f5d5d2d1f92de26: "Download Video",
  s302cbb19bf9a174a: "Off",
  s308604b3ae13fbb5: "Playing",
  s344ea8f4939cdc98: "Colour",
  s3687049d1af562c4: "Copy",
  s36b979e4de5152b3: "Link Copied",
  s37a9e8aec5713460: "More",
  s3ca1bdfa8785f808: "Proportional Sans Serif",
  s41faaf3b4e182cc6: "Age verification is required to access this content.",
  s49f06dca0feeb2f3: "Uniform",
  s4b023aafbd8d5ac8: "Share this video on",
  s4b10acae683d2978: "Fullscreen",
  s500caa88d20458d3: "You may not access this content",
  s5267658ceae3230f: "Share this video",
  s5c5db15dfc3a5376: "Playback rate",
  s5e3cb80d43a34044: "Black",
  s5e8250fb85d64c23: "Close",
  s669b18c6d2d9c95b: "None",
  s66d852e3c020e79e: "Opaque",
  s6a3bf589eaf72169: "Monospace Serif",
  s6baf78886c99db89: "Yellow",
  s6f59e9b81c5a47e0: "Drop Shadow",
  s711d047dea682c1a: "Audio Track",
  s7d148a08796094d2: "Playback Error",
  s81a19821f3e4a3d2: "Replay",
  s827bc70ebcb7bbc6: "Monospace Sans Serif",
  s85186a61e0d55bac: "Video",
  s889413eb7198ea01: "option for turning off caption",
  s8e408592fd4ae43a: "Text Edge Style",
  s8e985aeeca6a8166: "White",
  s8eafb22ebdc7e668: "Magenta",
  s9559a51a63cbb5fd: "Small Capitals",
  s95bc8722b2708f8b: "Paused",
  s973b83fb67a5865d: "Download Transcript",
  s9b3c2f9cc32d565a: "Cyan",
  s9c356016f81585f6: "Background Colour",
  s9d8b8aa2b404c2c8: "Settings",
  s9fbd543f2179c1ec: "Audio Menu",
  sa000eaf7092088c3: "Progress Bar",
  sa6f2645578b2d2bc: "Year",
  sa9011e79e3ca2d18: "Depressed",
  saf9b398ab363c174: "Please enter your date of birth",
  sb3d4f79d9d8b71e5: "Submit",
  sb47daaf9e1c4a905: "Month",
  sb9f16a5f9c29f41e: "We're sorry, but something went wrong.",
  sba64d8954d027206: "Opacity",
  sc07837c309cc699b: "Unmute",
  scd105819b5a10243: "Play",
  sce836928a17d96ed: "Text Colour",
  scf00d78fd5953f1c: "Green",
  sd1246235faaa3191: "An age restriction has been implemented due to mature themes or legal requirements intended to protect younger audiences.",
  sd3386a2ef42e80b9: "Download",
  sd8d4b1b613d28990: "Cursive",
  sdb02f53e62c1da05: "Raised",
  sdb73788b3c975f16: "Auto",
  se0955919920ee87d: "Day",
  se0f67eae944f8f94: "Mute",
  se73c59cc10f48c12: "Social",
  secf3d3a7c1693e2d: "Blue",
  sed31876562d94652: "Caption Settings",
  sf113fa256db9617b: "Ended",
  sf675f879b1c892c6: "Quality",
  sfc24a457269b13d4: "Volume Slider",
  sfcb817633bf70e1b: "Proportional Serif"
};
export {
  e as templates
};
